import React from "react";
import axios from "axios";

class AddToBasket extends React.Component {
  constructor(props) {
    super(props);
    this.addProductToBasket = this.addProductToBasket.bind(this);
    this.validateQuantity = this.validateQuantity.bind(this);
    this.changeQuantity = this.changeQuantity.bind(this);
    this.lineAdded = this.lineAdded.bind(this);
    this.state = {
      quantity: 1
    };
  }

  validateQuantity(qty) {
    if (!isNaN(parseFloat(qty)) && isFinite(qty) && qty >= 1) {
      this.setState({ quantity: parseInt(qty) });
    } else {
      this.setState({ quantity: 1 });
    }
  }

  changeQuantity(v) {
    switch (v) {
      case "increment":
        this.validateQuantity(this.state.quantity + 1);
        break;
      case "decrement":
        this.validateQuantity(this.state.quantity - 1);
        break;
    }
  }

  addProductToBasket() {
    axios
      .post(
        "/basket/add_line",
        {
          basket_line: {
            product_id: this.props.product_id,
            quantity: this.state.quantity
          }
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          }
        }
      )
      .then(() => {
        PubSub.publish("BASKET_UPDATE", "");
        this.lineAdded();
      })
      .catch(error => {
        // TODO: Error Handling
        console.log(error);
        alert("Error");
      });
  }

  lineAdded() {
    this.setState({
      line_added: true
    });
    setTimeout(() => {
      this.setState({
        line_added: false
      });
    }, 1000);
  }

  render() {
    let button_text =
      this.state.line_added === true ? "Item Added to Quote" : "Add To Quote";
    return (
      <div className="product-controls">
        <div className="quantity-controls">
          <span
            className="quantity-control quantity-control--decrement"
            onClick={() => this.changeQuantity("decrement")}
          >
            <i className="material-icons selected">&#xE15B;</i>
          </span>
          <input type="text" readOnly value={this.state.quantity} />
          <span
            className="quantity-control quantity-control--increment"
            onClick={() => {
              this.changeQuantity("increment");
            }}
          >
            <i className="material-icons selected">&#xE145;</i>
          </span>
        </div>
        <button className="product-controls__add-to-basket-btn" onClick={this.addProductToBasket}>{button_text}</button>
      </div>
    );
  }
}

export { AddToBasket };
